"use strict";
export { TagCloseTrigger as CloseTrigger, TagEndElement as EndElement, TagLabel as Label, TagRoot as Root, TagRootPropsProvider as RootPropsProvider, TagStartElement as StartElement } from './tag.js';
